/* global axios */
import ApiClient from './ApiClient';

// Kanban por etiqueta CLT: 1 chamada devolve todas as colunas (contagem real +
// primeiros cards, mais recentes primeiro); "Carregar mais" pagina UMA coluna.
class KanbanApi extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  getBoard({ inboxId } = {}) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId || undefined },
    });
  }

  getColumn({ label, offset, inboxId }) {
    return axios.get(this.url, {
      params: { label, offset, inbox_id: inboxId || undefined },
    });
  }
}

export default new KanbanApi();
